export default "<!-- Generated template for the OwnerNameComponent component -->\n<div>\n  {{funzState.owner.name}}\n</div>\n";